import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl, Radio} from "react-bootstrap";
import {TopButtonAction, TopButtonAdd} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import moment from 'moment'
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import {Link} from "react-router-dom";

export default class SzukajJednorazowychForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: moment(),
            dataDo: moment(),
            trasa: null,
            godz: null,
            error: false,

            czyDataSprzedazy: false
        }
        this.onChangeTrasy = this.onChangeTrasy.bind(this)
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeGodz = this.onChangeGodz.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
    };

    componentDidMount() {
        this.initDaty()
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.paramsObsady)) {

            let godzInput = nextprops.paramsObsady.godz
            if (godzInput.length === 4 && godzInput.indexOf(':') === 1) {
                godzInput = '0' + godzInput
            }

            this.setState({
                dataOd: moment(nextprops.paramsObsady.data),
                dataDo: moment(nextprops.paramsObsady.data),
                trasa: this.props.trasy.find(t => t.idTr === nextprops.paramsObsady.idTr),
                godz: nextprops.paramsObsady.godz
            })
            document.getElementById('inputGodzina').value = godzInput
        }

        if(nextprops.wyswietlanieDlaUrzedu){
            this.setState({czyDataSprzedazy:true})
        }
    }

    initDaty() {
        this.setState({
            dataOd: moment(),
            dataDo: moment(),
        })
    }

    formatTrasaSelect(option) {
        return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr}
            <TopDostepnosc wartoscWarunek={0}
                           wartosc={option.status}
                           czyMarginesLewy={true}/>
        </div>
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeTrasy(e) {
        this.setState({trasa: e})
    }

    onChangeGodz(e) {
        if (e.target.value !== '') {
            this.setState({godz: e.target.value})
        } else this.setState({godz: null})
    }

    onClickSzukaj() {
        this.setState({error: false})
        if (Boolean(this.state.dataOd) && Boolean(this.state.dataDo) && (this.state.dataDo >= this.state.dataOd)) {

            let data = {
                dataOd: (this.state.dataOd),
                dataDo: (this.state.dataDo),
                trasa: this.state.trasa,
                godz: this.state.godz,
                czyDataSprzedazy: this.state.czyDataSprzedazy
            }

            this.props.handleClickSzukaj(data)
        }
        else {
            this.setState({error: true})
        }
    }

    render() {

        return (
            <div>
                <Form horizontal={true}>
                    <FormGroup style={{marginBottom: '0'}}>

                        <Col xs={12} lg={this.props.wyswietlanieDlaUrzedu ? 4 :5}>
                            <Col xs={6} lg={4} style={{display: (this.props.wyswietlanieDlaUrzedu ? "none" : "block")}}>
                                <ControlLabel>Szukaj po dacie:</ControlLabel>
                                <div>
                                    <Radio inline={true} name={"WaznoscCzySprzedazRadio"} checked={!this.state.czyDataSprzedazy}
                                           onChange={() => this.setState({czyDataSprzedazy: false})}>ważności</Radio>
                                    <Radio inline={true} name={"WaznoscCzySprzedazRadio"} checked={this.state.czyDataSprzedazy}
                                           onChange={() => this.setState({czyDataSprzedazy: true})}>sprzedaży</Radio>
                                </div>
                            </Col>
                            <Col xs={6} lg={this.props.wyswietlanieDlaUrzedu ? 6 : 4}>
                                <ControlLabel>Data {!this.state.czyDataSprzedazy ? "ważności" : "sprzedaży"} od <span style={{color: 'red'}}>*</span></ControlLabel>
                                <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd} withoutIcon={true}/>
                            </Col>
                            <Col xs={6} lg={this.props.wyswietlanieDlaUrzedu ? 6 : 4}>
                                <ControlLabel>Data {!this.state.czyDataSprzedazy ? "ważności" : "sprzedaży"} do <span style={{color: 'red'}}>*</span></ControlLabel>
                                <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo} withoutIcon={true}/>
                            </Col>
                        </Col>
                        {
                            !this.props.wyswietlanieDlaUrzedu &&
                            <Col xs={6} lg={3}>
                                <ControlLabel>Trasa </ControlLabel>
                                <TopSelect onChange={this.onChangeTrasy}
                                           value={this.state.trasa}
                                           options={this.props.trasy}
                                           valueKey={'idTr'}
                                           labelKey={'nazTr'}
                                           valueRenderer={this.formatTrasaSelect}
                                           optionRenderer={this.formatTrasaSelect}
                                           placeholder={'Wybierz trasę...'}
                                />
                            </Col>
                        }
                        <Col xs={3} lg={1} style={{display: (this.props.wyswietlanieDlaUrzedu ? "none" : "block")}}>
                            <ControlLabel>Godz. odjazdu</ControlLabel>
                            <FormControl type={'time'} onChange={this.onChangeGodz} id={'inputGodzina'}/>
                        </Col>
                        <Col xs={6} lg={2}>
                            <div className={'add-label-margin'}></div>
                            <TopButtonAction text={'Szukaj biletów'} iconType={'fa fa-search'} onClick={this.onClickSzukaj} btnSize={'medium'}/>
                        </Col>
                        {
                            !this.props.ukryjPrzyciskDodaj ?
                                <Col xs={12} lg={1}>
                                    <div className={'pull-right'}>
                                        <div className={'add-label-margin'}></div>
                                        <Link to={'/konfiguracja/zarzadzanie-biletami/bilety/dodaj-jednorazowy'}>
                                            <TopButtonAdd onClick={() => {
                                            }}/>
                                        </Link>
                                    </div>
                                </Col>
                                :
                                ''
                        }
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12}>
                            <TopIf isTrue={this.state.error}>
                                <TopAlertUwaga text={'Obydwie daty muszą być poprawnie uzupełnione'}/>
                            </TopIf>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/biletyJednorazowe/components/SzukajJednorazowychForm.js